import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import {
    buildColumns,
    ConstrainMode,
    DetailsList,
    DetailsListLayoutMode,
    DetailsRow,
} from '@fluentui/react/lib/DetailsList';
import { useTranslation } from 'react-i18next';
import { ScrollablePane, ScrollbarVisibility, Sticky, StickyPositionType } from '@fluentui/react';

import { ListWrapper } from '../../styles';
import { copyAndSort } from '../../../../../../utils/copyAndSort';

const LocationsList = ({ list }) => {
    const [columns, setColumns] = useState([]);
    const [sortedItems, setSortedItems] = useState([]);

    const { t } = useTranslation();

    const items = (list || []).map((location) => {
        const { name, id, project_id } = location;

        // eslint-disable-next-line no-useless-computed-key
        return { name, ['location Id']: id, ['project Id']: project_id };
    });

    useEffect(() => {
        const columns = myBuildColumns(items);

        setColumns(columns);
        setSortedItems(items);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [list]);

    function myBuildColumns(items) {
        if (items.length === 0) return [];
        const columns = buildColumns(items);

        return columns;
    }

    const renderRow = (props) => {
        const customStyles = {
            root: {
                display: 'flex',
                backgroundColor: 'white',
            },
            cell: {
                display: 'flex',
                width: 'auto',
                alignItems: 'center',
            },
        };

        if (props) {
            if (props.itemIndex % 2 === 0) {
                customStyles.root = { display: 'flex', backgroundColor: '#eff6fc' };
            }

            return (
                <div>
                    <DetailsRow {...props} styles={customStyles} />
                </div>
            );
        } else {
            return null;
        }
    };

    function renderItemColumn(item, index, column) {
        if (!column || !column?.fieldName) {
            return null;
        }

        switch (column.key) {
            case 'navigate': {
                return null;
                // <DefaultButton
                //     text={t('Jump to project')}
                //     onClick={onNavigateUrl(item.navigate)}
                //     allowDisabledFocus
                // />
            }
            case 'location Id': {
                return (
                    <Link
                        to={`/projects/${item?.['project Id']}/project-locations/${item?.['location Id']}/installation-points`}
                    >{`${t('Jump to location')} ${item?.['location Id']}`}</Link>
                );
            }
            case 'project Id': {
                return (
                    <Link to={`/projects/${item?.['project Id']}`}>{`${t('Jump to project')} ${
                        item?.['project Id']
                    }`}</Link>
                );
            }

            default: {
                const fieldContent = item[column.fieldName];

                return <span>{fieldContent}</span>;
            }
        }
    }

    const onColumnClick = (event, column) => {
        const allowedKeys = ['id', 'name', 'location Id', 'project Id'];
        if (!column || !allowedKeys.includes(column.key)) return;
        let isSortedDescending = column.isSortedDescending;

        // If we've sorted this column, flip it.
        if (column.isSorted) {
            isSortedDescending = !isSortedDescending;
        }

        // Sort the items.
        const items = copyAndSort(sortedItems, column.fieldName, isSortedDescending);

        // Reset the items and columns to match the state.
        setSortedItems(items);
        setColumns(
            columns.map((col) => {
                col.isSorted = col.key === column.key;
                if (col.isSorted) {
                    col.isSortedDescending = isSortedDescending;
                }
                return col;
            }),
        );
    };

    const customTableHeader = (headerProps, defaultRender) => {
        if (!defaultRender) return null;
        return (
            <Sticky
                stickyPosition={StickyPositionType.Header}
                isScrollSynced={true}
                stickyBackgroundColor="transparent"
            >
                <div>{defaultRender(headerProps)}</div>
            </Sticky>
        );
    };

    return (
        <ListWrapper>
            <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                <DetailsList
                    onRenderDetailsHeader={customTableHeader}
                    layoutMode={DetailsListLayoutMode.fixedColumns}
                    onColumnHeaderClick={onColumnClick}
                    items={sortedItems}
                    onRenderItemColumn={renderItemColumn}
                    setKey="set"
                    columns={columns}
                    onRenderRow={renderRow}
                    selectionMode={0}
                    constrainMode={ConstrainMode.unconstrained}
                    // constrainMode={0}
                    isHeaderVisible={true}
                />
            </ScrollablePane>
        </ListWrapper>
    );
};

export default LocationsList;
